import {
  BILLING_URL,
  COMPANY_URL,
  LOCAL_URL,
  SITE_URL,
} from "../../constants/apiUrls";
import { apiSlice } from "../apiSlice";

export const companyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCompany: builder.mutation({
      query: ({ data, token }) => (
        {
          url: `api/company/create/`,
          method: "POST",
          body: data,
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
    }),
    // TIP-491 — raise a FREE, member-only verification request. The backend
    // gates this to active members (non-members get a 403 upsell).
    requestVerification: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/verify-request/`,
        method: "POST",
        body: { companyID },
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    // TIP-499 (MV Stage 1c) — persist the user's chosen default active company
    // per-Individual so it survives logout/login and follows them across
    // devices. Pass companyID: null to clear (revert to most-privileged).
    setDefaultCompany: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/individual-default-company/`,
        method: "POST",
        body: { companyID },
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    stripePaymentIntent: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/billing/stripe-payment/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createStripePayment: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/billing/stripe/create_payment/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateStripePayment: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/billing/stripe/update_payment/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    finalizeStripePayment: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/billing/stripe/finalize_payment/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    userSubscription: builder.mutation({
      query: ({ data }) => ({
        url: `api/company/subscription-status/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    createPurchaseDetails: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/purchase-details`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createCompanyViewedDetails: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-viewed-details/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getPurchaseDetails: builder.query({
      query: ({ userID, companyID, token }) => ({
        url: `api/company/purchase-details-get/${companyID}/${userID}/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyPurchaseDetails: builder.mutation({
      query: ({ userID, companyID, token }) => ({
        url: `api/company/purchase-details-get/${companyID}/${userID}/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyWorldboxstatus: builder.mutation({
      query: ({ userID, companyID }) => ({
        url: `api/company/worldbox-status/${companyID}/${userID}/`,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    getCompanyPurchaseDetails: builder.mutation({
      query: ({ userID, companyID, token }) => ({
        url: `api/company/purchase-details-get/${companyID}/${userID}/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyWorldboxstatus: builder.mutation({
      query: ({ userID, companyID }) => ({
        url: `api/company/worldbox-status/${companyID}/${userID}/`,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),

    getIndividual: builder.query({
      query: ({ token, individualID }) => ({
        url: `api/company/individual/${individualID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getIndividualPrompt: builder.query({
      query: ({ token, promptID }) => ({
        url: `api/gpt_prompts/${promptID}/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    individualCompany: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/individual-company/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateCompany: builder.mutation({
      query: ({ data, companyId, token }) => ({
        url: `api/company/details/${companyId}`,

        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateCompanyDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-draft/`,
        method: "POST",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateCompanyDraftEdit: builder.mutation({
      query: ({ data, companyId, token, type }) => ({
        url:
          type === "socialmedia"
            ? `api/company/company-draft-socialmedia/${companyId}`
            : type === "aboutcompany"
              ? `api/company/company-draft/${companyId}`
              : type === "bannerlogo"
                ? `api/company/company-draft-bannerlogo/${companyId}`
                : `api/company/company-draft/${companyId}`,
        method: "PUT",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    fetchCompanyDraftEdit: builder.mutation({
      query: ({ data, companyId, token }) => ({
        url: `api/company/company-draft/${companyId}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompany: builder.query({
      query: ({ token, companyId }) => ({
        url: `api/company/company-details/${companyId}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyReport: builder.mutation({
      query: ({ companyId, token }) => ({
        url: `api/company/details/report/${companyId}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },

      }),
    }),

    getBPCompany: builder.query({
      query: ({ purchaseSubScriptionValid, isClaimed, token, companyId, role }) => ({
        url: `api/company/${(isClaimed || purchaseSubScriptionValid || role) ? 'details' : 'basic-details'
          }/${companyId}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getOptimisedCompanyDetails: builder.query({
      query: ({ token, companyId }) => ({
        url: `api/company/company-details/${companyId}`,
        headers: token ? {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        } :
          {
            "content-type": "application/json",
          },
      }),
    }),
    getCompanyDetails: builder.mutation({
      query: ({ token, companyId }) => ({
        url: `api/company/details/${companyId}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCurrentUser: builder.query({
      query: ({ token }) => ({
        url: `api/api/user/me/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    searchTrevexCompany: builder.query({
      query: ({ token, searchTerm, code }) => ({
        url: `api/company/details/?search=${searchTerm}&country_code=${code}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createFinance: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/financial/`,
        method: "POST",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createFinanceDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/financial-draft/`,
        method: "POST",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateFinanceDraftDetails: builder.mutation({
      query: ({ data, token, company_financialID }) => ({
        url: `api/company/financial-draft/${company_financialID}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createFinanceDraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/finanicaldraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createInsuranceDraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/insurancedraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createOwnershipDraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/ownershipdetailsdraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    businessRelationDraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/businessrelationsdraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    relatedEntityDraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/relatedentitydraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createauthorizedsignDraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/authorizedsigndraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    bankdetailsdraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/bankdetailsdraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    keypersonneldetailsdraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/keypersonneldetailsdraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    addressdetailsdraftFetch: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/addressdetailsdraft?current_companyID=${companyID}`,
        method: "GET",
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateFinance: builder.mutation({
      query: ({ data, company_financialID, token }) => ({
        url: `api/company/financial/${company_financialID}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getFinancial: builder.query({
      query: ({ token, company_financialID }) => ({
        url: `api/company/financial/${company_financialID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getBankData: builder.query({
      query: ({ token, bankID }) => ({
        url: `api/company/bank/${bankID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getBankByIban: builder.mutation({
      query: ({ iban, token }) => ({
        url: `api/company/bank/iban/?iban=${iban}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateFinanceDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/financial-draft/`,
        method: "POST",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createCompanyFinance: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/financial/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createCompanyFinanceDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/financial-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    uploadFinanceDocument: builder.mutation({
      query: ({ data, token, company_id }) => ({
        url: `api/company/financial-data/${company_id}/upload_data/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateFinanceCurrency: builder.mutation({
      query: ({ data, token, companyId }) => ({
        url: `api/company/financial-data/${companyId}/update_currency_units/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    uploadFinanceDocuments: builder.mutation({
      query: ({ data, token, companyId, location = 'upload' }) => ({
        url: `api/company/financial-data/${companyId}/financial_document/?location=${location}`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getDocumentToFillData: builder.mutation({
      query: ({ token, companyId }) => ({
        url: `api/company/financial-data/${companyId}/get_financial_document/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    uploadFinanceDocumentsData: builder.mutation({
      query: ({ data, token, companyId }) => ({
        url: `api/company/financial-data/${companyId}/upload_data/?filled-form=true`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyFinanceChartData: builder.mutation({
      query: ({ token, company_id, location }) => ({
        url: `api/company/financial-data/${company_id}/get_graph/?location=${location}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createCompanyFollow: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-follow/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    deleteCompanyFollow: builder.mutation({
      query: ({ id, token }) => ({
        url: `api/company/delete_company_follow/${id}/`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createCompanyFollowUpdate: builder.mutation({
      query: ({ companyID, content, token }) => ({
        url: `api/company/company-updates/`,
        method: "POST",
        body: JSON.stringify({
          companyID: companyID,
          content: content,
        }),
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCompanyUpdates: builder.query({
      query: ({ companyID, token }) => ({
        url: `api/company/company-updates/?companyID=${companyID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateViewedTimestamp: builder.mutation({
      query: ({ followID, token }) => ({
        url: `api/company/update-viewed-timestamp/${followID}/`,
        method: "PUT",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createAddressDetails: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-address-details/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    editAddressDetailsDraft: builder.mutation({
      query: ({ data, token, company_address_details_draftID }) => ({
        url: `api/company/company-address-details-draft/${company_address_details_draftID}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createAddressDetailsDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-address-details-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    authorizedSign: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/authorized-sign/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    authorizedSignDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/authorized-sign-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateAuthorizedSign: builder.mutation({
      query: ({ data, authorized_signID, token }) => ({
        url: `api/company/authorized-sign/${authorized_signID}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateAuthorizedSignDraft: builder.mutation({
      query: ({ data, token, authorized_signID }) => ({
        url: `api/company/authorized-sign-draft/${authorized_signID}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createAuthorizedSign: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-authorized-sign/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createAddressDetailsUpdate: builder.mutation({
      query: ({ data, token, company_address_detailsID }) => ({
        url: `api/company/company-address-details/${company_address_detailsID}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createAddress: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-address/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    industry: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/industry/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createInsurance: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/insurance/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createInsuranceDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/insurance-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateInsuranceDraft: builder.mutation({
      query: ({ data, insuranceID, token }) => ({
        url: `api/company/insurance-draft/${insuranceID}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateInsurance: builder.mutation({
      query: ({ data, insuranceID, token }) => ({
        url: `api/company/insurance/${insuranceID}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createOwnershipCompanyDetails: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/ownership-company-details/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createOwnershipCompanyDetailsDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/ownership-company-details-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateOwnershipCompanyDetails: builder.mutation({
      query: ({ data, ownership_compId, token }) => ({
        url: `api/company/ownership-company-details/${ownership_compId}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createOwnershipIndividual: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/ownership-individual/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createOwnershipIndividualDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/ownership-individual-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateOwnershipCompanyDetailsDraft: builder.mutation({
      query: ({ data, token, ownershipdraftID }) => ({
        url: `api/company/ownership-company-details-draft/${ownershipdraftID}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateOwnershipIndividualDraft: builder.mutation({
      query: ({ data, token, ownershipdraftID }) => ({
        url: `api/company/ownership-individual-draft/${ownershipdraftID}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateOwnershipIndividual: builder.mutation({
      query: ({ data, ownership_indId, token }) => ({
        url: `api/company/ownership-individual/${ownership_indId}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createOwnership: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/ownership/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createOwnershipCompany: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/ownership-company/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    deleteOwnershipCompanyDetails: builder.mutation({
      query: ({ companyID, token }) => ({
        url: `api/company/delete_ownership/${companyID}/`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createKeyPersonnel: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/key-personnel/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createKeyPersonnelDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/key-personnel-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateKeyPersonnel: builder.mutation({
      query: ({ data, key_personnelId, token }) => ({
        url: `api/company/key-personnel/${key_personnelId}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateKeyPersonnelDraft: builder.mutation({
      query: ({ data, token, key_personnelId }) => ({
        url: `api/company/key-personnel-draft/${key_personnelId}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createCompanyKeyPersonnel: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/company-key-personnel/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createRelatedEntity: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/related-entity/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createRelatedEntityDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/related-entity-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateRelatedEntity: builder.mutation({
      query: ({ data, related_entityId, token }) => ({
        url: `api/company/related-entity/${related_entityId}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateRelatedEntityDraft: builder.mutation({
      query: ({ data, token, related_entityId }) => ({
        url: `api/company/related-entity-draft/${related_entityId}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createBusinessRelation: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/business-relation/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createBusinessRelationDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/business-relation-draft/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateBusinessRelation: builder.mutation({
      query: ({ data, business_relationId, token }) => ({
        url: `api/company/business-relation/${business_relationId}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateBusinessRelationDraft: builder.mutation({
      query: ({ data, token, business_relationId }) => ({
        url: `api/company/business-relation-draft/${business_relationId}`,
        method: "PATCH",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    createBank: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/bank/`,
        method: "POST",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createBankDraft: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/bank-draft/`,
        method: "POST",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateBank: builder.mutation({
      query: ({ data, bankId, token }) => ({
        url: `api/company/bank/${bankId}`,
        method: "PATCH",
        body: data,
        headers: {

          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateBankDraft: builder.mutation({
      query: ({ data, bankId, token }) => ({
        url: `api/company/bank-draft/${bankId}`,
        method: "PATCH",
        body: data,
        headers: {

        },
      }),
    }),
    GetClaimed: builder.mutation({
      query: ({ data, token }) => {
        if (!token) {
          throw new Error("Authorization token is missing.");
        };
        return {
          url: `api/admins/company-admin-request/`,
          method: "POST",
          body: data,
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    getCompanyClaimed: builder.mutation({
      query: ({ data, token }) => {
        if (!token) {
          throw new Error("Authorization token is missing.");
        };
        return {
          url: `api/company/claimdraft/create_claim/`,
          method: "POST",
          body: data,
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    getCompanyUserList: builder.mutation({
      query: ({ data, token }) => {
        return {
          url: `api/company/individual-company-invite/get_list/`,
          method: "POST",
          body: { company_id: data.id },
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    createCompanyUserInvite: builder.mutation({
      query: ({ data, token }) => {
        if (!token) {
          throw new Error("Authorization token is missing.");
        }
        return {
          url: `api/company/individual-company-invite/invite_user/`,
          method: "POST",
          body: data,
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    createCompanyUserRoleUpdate: builder.mutation({
      query: ({ data, token }) => {
        return {
          url: `api/company/individual-company-invite/change_role/`,
          method: "POST",
          body: data,
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    createCompanyUserRoleDelete: builder.mutation({
      query: ({ data, token }) => {
        return {
          url: `api/company/individual-company-invite/delete_role/`,
          method: "POST",
          body: data,
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };
      },
    }),
    createWorldBoxOrder: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/wordbox-order/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createWorldBoxCompany: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/wordbox-order-without-win/create_order/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
      }),
    }),
    getCompanyRequestStatus: builder.mutation({
      query: ({ companyID, individualID, token }) => ({
        url: `api/admins/company-admin-request-status?company_id=${companyID}&individual_id=${individualID}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    updateCompanyRequestStatus: builder.mutation({
      query: ({ requestID, token }) => ({
        url: `api/admins/update-admin-status?requestID=${requestID}`,
        method: "PUT",
        body: { status: "Modified" },
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getUserPurchaedData: builder.query({
      query: ({ token, id }) => ({
        url: `api/company/user-purchased-companies?id=${id}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getUserSubscriptionList: builder.query({
      query: ({ individualID, token }) => ({
        url: `api/company/subscription-list/${individualID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getVerifyCompanyPayment: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/company/verify-company-payment`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getVerifyCompanyPaymentFetch: builder.query({
      query: ({ individualID, token }) => ({
        url: `api/company/verify-company-payment-list/${individualID}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    getVerifyCompanyPaymentEmail: builder.mutation({
      query: ({ token, CompanyID, individualID }) => ({
        url: `api/company/verify-company-payment-email/${CompanyID}/${individualID}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    deleteBankDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-bank-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteInsuranceDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-insurance-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteBusinessRelationDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-businessrelation-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteRelatedEntityDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-relatedentity-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteKeyPersonnelDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-keypersonnel-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteAddressDetailsDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-address-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteAuthSignDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-authsign-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteOwnershipCompDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-ownership-company-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteOwnershipIndDraft: builder.mutation({
      query: (data) => ({
        url: `api/company/delete-ownership-individual-draft/${data.data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),

    addEndorsement: builder.mutation({
      query: ({ companyId, endorsementData, token }) => ({
        url: `api/company/endorsements/${companyId}/add/`,
        method: 'POST',
        body: endorsementData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    deleteEndorsement: builder.mutation({
      query: ({ endorsementId, token }) => ({
        url: `api/company/endorsements/remove/${endorsementId}/`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    // TIP-504 — member-gated endorsement view. Pass the viewer's active company
    // so the backend (TIP-492) decides member (returns `endorsements`) vs
    // non-member (returns a teaser: `endorsement_count` + `message`).
    getEndorsements: builder.query({
      query: ({ companyId, actingCompanyId, token }) => ({
        url: `api/company/endorsements/${companyId}/?list&acting_company_id=${actingCompanyId ?? ''}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getActiveEnterprise: builder.query({
      query: ({ token }) => ({
        url: `api/enterprise/active-enterprise-solutions/?page=${1}&page_size=${100}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getTrackCompanyList: builder.query({
      query: ({ token, id, page, limit, searchTerm }) => ({
        url: `api/enterprise/active-enterprise-tracked/${id}/?company_name=${searchTerm}&page=${page}&page_size=${limit}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getUpdateViewedTime: builder.mutation({
      query: ({ token, id }) => ({
        url: `api/enterprise/update_viewed_time/${id}/`,
        method: 'GET',
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    addCompanyToEnterprise: builder.mutation({
      query: ({ token, data }) => ({
        url: `${LOCAL_URL}/enterprise/add-company-to-enterprise/`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    createOrderForEnterprise: builder.mutation({
      query: ({ token, data }) => ({
        url: `${LOCAL_URL}/enterprise/create-order-for-company/`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    requestDemoTriggerForAdmin: builder.mutation({
      query: ({ requestData }) => ({
        url: `api/company/calendly/invite-details/`,
        method: 'POST',
        body: requestData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    createCorporateTax: builder.mutation({
      query: ({ token, data }) => ({
        url: `api/company/corporate-tax/dashboard/create_tax/`,
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getAvailableCategory: builder.query({
      query: ({ token, id }) => ({
        url: `api/company/corporate-tax/dashboard/available_categories/?company_id=${id}`,
        method: 'GET',
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getCategoryList: builder.mutation({
      query: ({ token, id }) => ({
        url: `api/company/corporate-tax/dashboard/get_list/`,
        method: 'POST',
        body: { company_id: id },
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateCategory: builder.mutation({
      query: ({ token, data }) => ({
        url: `api/company/corporate-tax/dashboard/edit_tax/`,
        method: 'POST',
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    deleteCategory: builder.mutation({
      query: ({ token, data }) => ({
        url: `api/company/corporate-tax/dashboard/delete_tax/`,
        method: 'POST',
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getMagicToken: builder.mutation({
      query: ({ token }) => ({
        url: `api/user/magic-token/`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getSubIndustriesData: builder.query({
      query: ({ token }) => ({
        url: `api/company/sub-industry/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      providesTags: ['SubIndustries'], // static tag
      keepUnusedDataFor: 300, // 5 minutes
    }),
    updateClaimDraft: builder.mutation({
      query: ({ token, data, url }) => ({
        url: `api/company/${url}/`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    updateTradeLicense: builder.mutation({
      query: ({ data }) => ({
        url: `api/company/trade-license-request/upload_request/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    getTraderData: builder.query({
      query: ({ fileToken }) => ({
        url: `api/company/trade-license-request/${fileToken}/get_information/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    getAssignedReferenceRequests: builder.query({
      query: (token) => ({
        url: `/api/payment-reference/user/get-assigned-reference-requests/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getReferenceWithAnswers: builder.mutation({
      query: ({token, id}) => ({
        url: `/api/payment-reference/user/submit-reference/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    submitReferenceWithAnswers: builder.mutation({
      query: ({token, id, data}) => ({
        url: `/api/payment-reference/user/submit-reference/${id}/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getAssignedReferenceQuestions: builder.query({
      query: ({token, id}) => ({
        url: `/api/payment-reference/user/reference-questions/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getEnterpriseSolutionStats: builder.mutation({
      query: ({token, id}) => ({
        url: `/api/enterprise/enterprise-solution-stats/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    uploadEnterpriseLink: builder.mutation({
      query: ({data, token}) => ({
        url: `/api/enterprise/upload-enterprise-file/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const {
  useGetUserPurchaedDataQuery,
  useCreateCompanyMutation,
  useRequestVerificationMutation,
  useSetDefaultCompanyMutation,
  useGetUserSubscriptionListQuery,
  useGetCompanyQuery,
  useGetCurrentUserQuery,
  useGetFinancialQuery,
  useGetIndividualQuery,
  useGetIndividualPromptQuery,
  useSearchTrevexCompanyQuery,
  useIndustryMutation,
  useUpdateCompanyMutation,
  useUpdateCompanyDraftMutation,
  useUpdateCompanyDraftEditMutation,
  useFetchCompanyDraftEditMutation,
  useCreateAddressDetailsMutation,
  useCreateAddressDetailsDraftMutation,
  useEditAddressDetailsDraftMutation,
  useCreateAddressMutation,
  useCreateAddressDetailsUpdateMutation,
  useCreatePurchaseDetailsMutation,
  useGetPurchaseDetailsQuery,
  useGetCompanyPurchaseDetailsMutation,
  useAuthorizedSignMutation,
  useGetBPCompanyQuery,
  useGetOptimisedCompanyDetailsQuery,
  useAuthorizedSignDraftMutation,
  useCreateAuthorizedSignMutation,
  useUpdateAuthorizedSignMutation,
  useUpdateAuthorizedSignDraftMutation,
  useGetVerifyCompanyPaymentMutation,
  useGetVerifyCompanyPaymentEmailMutation,
  useCreateFinanceMutation,
  useCreateFinanceDraftMutation,
  useCreateFinanceDraftFetchMutation,
  useCreateCompanyFinanceMutation,
  useUploadFinanceDocumentMutation,
  useUpdateFinanceCurrencyMutation,
  useUploadFinanceDocumentsMutation,
  useGetDocumentToFillDataMutation,
  useUploadFinanceDocumentsDataMutation,
  useCreateCompanyFinanceDraftMutation,
  useUpdateFinanceMutation,
  useGetCompanyFinanceChartDataMutation,
  useUpdateFinanceDraftMutation,
  useIndividualCompanyMutation,
  useCreateInsuranceMutation,
  useUpdateInsuranceMutation,
  useCreateOwnershipCompanyMutation,
  useCreateOwnershipMutation,
  useCreateOwnershipIndividualMutation,
  useUpdateOwnershipIndividualMutation,
  useCreateOwnershipCompanyDetailsMutation,
  useUpdateOwnershipCompanyDetailsMutation,
  useCreateKeyPersonnelMutation,
  useCreateKeyPersonnelDraftMutation,
  useCreateCompanyKeyPersonnelMutation,
  useUpdateKeyPersonnelMutation,
  useUpdateKeyPersonnelDraftMutation,
  useCreateRelatedEntityMutation,
  useCreateRelatedEntityDraftMutation,
  useUpdateRelatedEntityMutation,
  useUpdateRelatedEntityDraftMutation,
  useCreateBusinessRelationMutation,
  useCreateBusinessRelationDraftMutation,
  useUpdateBusinessRelationMutation,
  useUpdateBusinessRelationDraftMutation,
  useCreateBankMutation,
  useCreateBankDraftMutation,
  useUpdateBankMutation,
  useUpdateBankDraftMutation,
  useCreateCompanyFollowMutation,
  useDeleteCompanyFollowMutation,
  useCreateCompanyFollowUpdateMutation,
  useGetCompanyUpdatesQuery,
  useUpdateViewedTimestampMutation,
  useCreateOwnershipCompanyDetailsDraftMutation,
  useGetClaimedMutation,
  useGetCompanyClaimedMutation,
  useCreateOwnershipIndividualDraftMutation,
  useStripePaymentIntentMutation,
  useCreateStripePaymentMutation,
  useUpdateStripePaymentMutation,
  useFinalizeStripePaymentMutation,
  useUserSubscriptionMutation,
  useGetBankDataQuery,
  useGetBankByIbanMutation,
  useCreateInsuranceDraftMutation,
  useCreateCompanyViewedDetailsMutation,
  useGetCompanyUserListMutation,
  useCreateCompanyUserInviteMutation,
  useCreateCompanyUserRoleUpdateMutation,
  useCreateCompanyUserRoleDeleteMutation,
  useCreateWorldBoxOrderMutation,
  useCreateWorldBoxCompanyMutation,
  useGetCompanyDetailsMutation,
  useGetCompanyRequestStatusMutation,
  useUpdateCompanyRequestStatusMutation,
  useUpdateFinanceDraftDetailsMutation,
  useCreateInsuranceDraftFetchMutation,
  useCreateOwnershipDraftFetchMutation,
  useBusinessRelationDraftFetchMutation,
  useRelatedEntityDraftFetchMutation,
  useCreateauthorizedsignDraftFetchMutation,
  useBankdetailsdraftFetchMutation,
  useKeypersonneldetailsdraftFetchMutation,
  useAddressdetailsdraftFetchMutation,
  useGetCompanyWorldboxstatusMutation,
  useDeleteOwnershipCompanyDetailsMutation,
  useUpdateInsuranceDraftMutation,
  useUpdateOwnershipCompanyDetailsDraftMutation,
  useUpdateOwnershipIndividualDraftMutation,
  useGetVerifyCompanyPaymentFetchQuery,
  useDeleteBankDraftMutation,
  useDeleteInsuranceDraftMutation,
  useDeleteBusinessRelationDraftMutation,
  useDeleteRelatedEntityDraftMutation,
  useDeleteKeyPersonnelDraftMutation,
  useDeleteAddressDetailsDraftMutation,
  useDeleteAuthSignDraftMutation,
  useDeleteOwnershipCompDraftMutation,
  useDeleteOwnershipIndDraftMutation,
  useGetCompanyReportMutation,
  useAddEndorsementMutation,
  useDeleteEndorsementMutation,
  useGetEndorsementsQuery,
  useGetActiveEnterpriseQuery,
  useGetTrackCompanyListQuery,
  useGetUpdateViewedTimeMutation,
  useAddCompanyToEnterpriseMutation,
  useCreateOrderForEnterpriseMutation,
  useRequestDemoTriggerForAdminMutation,
  useCreateCorporateTaxMutation,
  useGetAvailableCategoryQuery,
  useGetCategoryListMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetMagicTokenMutation,
  useGetSubIndustriesDataQuery,
  useUpdateClaimDraftMutation,
  useUpdateTradeLicenseMutation,
  useGetTraderDataQuery,
  useGetAssignedReferenceRequestsQuery,
  useGetReferenceWithAnswersMutation,
  useSubmitReferenceWithAnswersMutation,
  useGetAssignedReferenceQuestionsQuery,
  useGetEnterpriseSolutionStatsMutation,
  useUploadEnterpriseLinkMutation
} = companyApiSlice;
